import axios from "axios";
import UNIVERSAL from "../Config/Config.js";

/**
 * Common Dynamic Excel Download Function
 * Supports: GET / POST | Token | Body | File Name
 *
 * @param {String} apiEndpoint - API URL after BASEURL
 * @param {String} fileName - Downloaded Excel file name
 * @param {String} method - "GET" or "POST"
 * @param {Object} body - POST request body (optional)
 * @param {String} token - Authorization token (optional)
 */
export const downloadExcel = async (
    apiEndpoint,
    fileName,
    method = "POST",
    body = {},
    token = null
) => {
    try {
        const config = {
            method: method,
            url: UNIVERSAL.BASEURL + apiEndpoint,
            data: body,
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
                token: token ? `${token}` : "",
            },
        };
        const response = await axios(config);

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
    }
};
